<template>
  <div id="app">
    <hybhead title="关于我们" ></hybhead>
                <div class="page-div"></div>

    <div class="mar-100"></div>
    <div class="about-h"></div>
    <div class="about-m"></div>
    <div class="about-text">
      <p>这是一种熟人社交软件，主要特色是伪装；</p>
      <p>它安装在手机里是普通的计算器或者新闻头条等APP，输入密码后会变成了聊天APP； 在使用聊天APP时，若遇到紧急情况，可一秒伪装成普通的APP，极度隐蔽。</p>
      <p>另外，伪装APP不会获取你的手机通讯录，也不会把你推荐给可能认识的人， 保护你的隐私安全。 避免无用社交，在伪装APP里只出现你最重要的人！</p>
    </div>

    <div class="about-z">
      <div>
        <p>专业</p>
        <span>我们有实力雄厚的管理团队，带领资深开发团队，使用最安全的技术，保障您的信息、隐私安全，让你拥有功能强大的聊天APP。</span>
      </div>
    </div>

    <div class="about-g">
      <div>
        <p>个性化</p>
        <span>我们将永远秉持最前沿的服务理念，为您提供最人性化的服务。还有私人订制，满足您的各种奇思妙想。</span>
      </div>
      <div>
        <p>隐秘</p>
        <span>总有不适合公开的对话、总有不适合私密对话的时间和地点总有必须要私聊的对方、总有不得不私密对话的需要...</span>
      </div>
    </div>
    <div class="about-text2">
      <p>深圳市无间数码科技有限公司是一家互联网企业，致力于为广大网友提供实用的聊天软件。 好运吧是旗下加密聊天产品，是一款加上外壳的聊天APP，我们会使用安全的技术， 保障您的信息、隐私安全。</p>
    </div>
    <div class="about-b">保护隐私，为您的安全聊天保驾护航</div>

    <div class="about-y">隐私政策 ></div>
    <div class="about-hr"></div>

 
      <hybfoot></hybfoot>
  </div>
</template>
<script>
import hybhead from "../views/common/head";
import hybfoot from "../views/common/foot";


export default {
  metaInfo: {
    title: "私密聊天软件是什么-好运吧",
    meta:[
      {
        name:'keyWords',
        content:'什么是好运吧私密聊天软件'
      },
      {
        name:'description',
        content:'好运吧私密聊天软件是一款主打熟人社交的聊天软件，无论是在外观伪装上还是功能隐蔽上，都能对聊天对象和记录做到安全私密。'
      }
    ]
  },
  name: "app",
  data() {
    return {
      msg: "注册协议Index"
    };
  },
  computed: {},
  mounted() {},
  components: {
    hybhead,hybfoot
  }
};
</script>
<style  scoped>
#app{
      background: #FAFAFA;
}
.mar-100 {
  width: 100%;
  height: 100px;
}

.page-div{
  width: 100%;
  height: 100px;
} 
.about-h {
  background: url("../assets/img/about-1.png");
  width: 636px;
  height: 98px;
  margin: 0 auto;
  background-size: 100%;
}
.about-m {
  background: url("../assets/img/about-2.png");
  width: 260px;
  height: 440px;
  margin: 40px auto 0 auto;
  background-size: 100%;
}
.about-text {
  width: 652px;
  height: 348px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 36px;
  margin: 0 auto;
  text-align: left;
}
.about-text2 {
  width: 652px;
  height: 90px;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 36px;
  margin: 0 auto;
  text-align: left;
}
.about-z {
  background: url("../assets/img/about-3.png");
  width: 500px;
  height: 500px;
  margin: 151px auto 10px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 100%;
}

.about-z div {
  width: 271px;
  height: 250px;
}

.about-z div p {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  line-height: 22px;
}
.about-z div span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}

.about-g {
  width: 700px;
  margin: 0 auto;
  display: flex;
}

.about-g div {
  flex: 1;
  justify-content: center;
}

.about-g div p {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  line-height: 22px;
}
.about-g div span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}
.about-b {
  width: 750px;
  height: 28px;
  margin: 151px auto 0 auto;
}

.about-hr {
  width: 690px;
  height: 1px;
  background: #eeeeee;
}
.about-y {
  width: 133px;
  height: 19px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #006cff;
  line-height: 26px;
  margin: 39px auto 100px auto;
}



</style>


// WEBPACK FOOTER //
// src/views/about.vue